import { render, staticRenderFns } from "./GantChartModal.vue?vue&type=template&id=3ade9008&scoped=true&"
import script from "./GantChartModal.vue?vue&type=script&lang=js&"
export * from "./GantChartModal.vue?vue&type=script&lang=js&"
import style0 from "./GantChartModal.vue?vue&type=style&index=0&id=3ade9008&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade9008",
  null
  
)

export default component.exports